import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Disclaimer } from "@/components/kit";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { CheckCircle2, Circle, Route } from "lucide-react";

export default function Journey() {
  const [j, setJ] = useState(null);
  useEffect(() => { api.get("/client/journey").then(({ data }) => setJ(data)); }, []);
  if (!j) return <div className="h-40 animate-pulse bg-secondary rounded-2xl" />;

  return (
    <div>
      <PageHeader title="Minha Jornada" subtitle="Seu período entre uma consulta e outra" />

      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <Card className="p-6">
          <div className="text-sm text-muted-foreground">Consulta anterior</div>
          <div className="font-heading text-xl font-semibold mt-1">
            {j.last_appointment ? new Date(j.last_appointment.date + "T00:00").toLocaleDateString("pt-BR") : "—"}
          </div>
        </Card>
        <Card className="p-6">
          <div className="text-sm text-muted-foreground">Próxima consulta</div>
          <div className="font-heading text-xl font-semibold mt-1">
            {j.next_appointment ? new Date(j.next_appointment.date + "T00:00").toLocaleDateString("pt-BR") : "—"}
          </div>
        </Card>
      </div>

      <Card className="p-6 mb-6">
        <div className="flex items-center gap-2 text-primary mb-3"><Route className="w-5 h-5" /><h3 className="font-heading font-medium">Progresso</h3></div>
        <div className="flex justify-between text-sm text-muted-foreground mb-1"><span>{j.completed_exercises} de {j.total_exercises} concluídas</span><span className="font-medium text-foreground">{j.progress}%</span></div>
        <Progress value={j.progress} className="h-3" />
        <p className="text-sm text-muted-foreground mt-3">Continue realizando suas atividades até a próxima consulta.</p>
      </Card>

      <h3 className="font-heading font-medium mb-3">Atividades</h3>
      <Card className="divide-y divide-border">
        {j.activities.map((a) => {
          const done = a.status === "completed";
          return (
            <div key={a.id} className="flex items-center gap-3 p-4" data-testid={`journey-activity-${a.id}`}>
              {done ? <CheckCircle2 className="w-5 h-5 text-accent shrink-0" /> : <Circle className="w-5 h-5 text-muted-foreground shrink-0" />}
              <div className="flex-1"><span className={done ? "line-through text-muted-foreground" : "font-medium"}>{a.name}</span></div>
              <span className="text-xs text-muted-foreground">{a.progress}%</span>
            </div>
          );
        })}
        {j.activities.length === 0 && <div className="p-6 text-center text-muted-foreground text-sm">Nenhuma atividade recomendada ainda.</div>}
      </Card>

      <Disclaimer />
    </div>
  );
}
